// images @ ui/src/components/static/

import React, { Component } from 'react'
import HomeCN from './HomeCN';
import HomeEN from './HomeEN';
import './home.css'

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const images = importAll(require.context('./static', false));
//console.log('images:', images)


class Home extends Component {
  constructor(props) {
    super(props)
    this.topFunction = this.topFunction.bind(this);
    this.handleClick = this.handleClick.bind(this)
    this.state = {
      isLangToggled: true,
    }
  }

  handleClick() {
    this.setState(prevState => ({
      isLangToggled: !prevState.isLangToggled
    }));
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }


  render() {
    return (
      <section className="mx-5" style={{ maxWidth: "100%" }} >
        {/* <label className="label is-normal has-text-success is-size-7 has-text-right">“Simplicity is the ultimate sophistication(大道至简)”, Leonardo da Vinci</label> */}
        <button className="button is-success" onClick={this.handleClick}>
          {this.state.isLangToggled ? `\u27A9 English` : '\u27A9 Chinese'}
        </button>
        {(!this.state.isLangToggled) && < HomeEN /> }
        {(this.state.isLangToggled) && < HomeCN /> }

      </section>
    )
  }
}

export default Home